import { render } from "./PhotosArticles.vue?vue&type=template&id=70a0a46f"
import script from "./PhotosArticles.vue?vue&type=script&lang=js"
export * from "./PhotosArticles.vue?vue&type=script&lang=js"

import "./PhotosArticles.vue?vue&type=style&index=0&id=70a0a46f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__